import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  readonly #http = inject(HttpClient);

  session(redirectUrl: string): Observable<Session> {
    return this.#http.get<Session>('/me', { withCredentials: true }).pipe(
      catchError((err) => {
        this.signIn(redirectUrl);
        return of('error', err);
      }),
    );
  }

  signIn(redirectUrl: string) {
    const url = 'oidcUrl' in environment ? environment['oidcUrl'] : environment['backendUrl'];
    window.location.href = `${url}/oidc/sign-in?redirect=${redirectUrl}`;
  }

  signOut = () => this.#http.get('/oidc/sign-out/callback').subscribe(() => (window.location.href = '/'));
}

export interface Session {
  name: string;
  claims: { roles: string; [key: string]: string };
}
